import type { IconNode } from '../types';

/**
 * @name feather-plus
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMiA3aDYiIC8+CiAgPHBhdGggZD0iTTUgNHY2IiAvPgogIDxwYXRoIGQ9Ik01LjEgMTdIMTRsOC04LjJjLTIuMy0yLjMtNi4xLTIuMy04LjUgMEwyLjEgMjAiIC8+CiAgPHBhdGggZD0iTTE4IDEzSDkuMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/feather-plus
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const featherPlus: IconNode = [
  ['path', { d: 'M2 7h6', key: '65393g' }],
  ['path', { d: 'M5 4v6', key: 'a6zo7q' }],
  ['path', { d: 'M5.1 17H14l8-8.2c-2.3-2.3-6.1-2.3-8.5 0L2.1 20', key: '6plgz7' }],
  ['path', { d: 'M18 13H9.2', key: 't3o44x' }],
];

export default featherPlus;
